<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />

    <b-card>
      <loading v-if="vLoading" />
      <b-tabs pills card content-class="mt-3">
        <b-tab title="عمومی" active>
          <b-card header-bg-variant="secondary" header-text-variant="light">
            <template v-slot:header>
              <h5>پروفایل انبار</h5>
            </template>
            <p>
              نام انبار: <strong>{{ warehouseInfo.name }}</strong>
            </p>
            <p>
              نوع انبار: <strong>{{ warehouseInfo.warehouseTypeName }}</strong>
            </p>
            <p v-if="warehouseInfo.description">
              توضیحات: <strong>{{ warehouseInfo.description }}</strong>
            </p>
          </b-card>
        </b-tab>

        <b-tab title="موجودی‌ها">
          <b-card header-bg-variant="secondary" header-text-variant="light">
            <template v-slot:header>
              <h5>
                اقلام موجود در <em>{{ warehouseInfo.name }}</em>
              </h5>
            </template>

            <b-table
              responsive
              show-empty
              id="productsTable"
              :items="warehouseInfo.allItems"
              :fields="fields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="currentPage"
              :per-page="perPage"
              :busy="isBusy"
              :filter="filter"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(identifierFa)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    :href="
                      '/warehouse/' +
                      type.slug +
                      '/' +
                      data.item.warehouseItemId
                    "
                    target="_blank"
                    >{{ data.value }}</a
                  >
                </div>
              </template>
              <template v-slot:cell(identifierEn)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    :href="
                      '/warehouse/' +
                      type.slug +
                      '/' +
                      data.item.warehouseItemId
                    "
                    target="_blank"
                    >{{ data.value }}</a
                  >
                </div>
              </template>

              <template v-slot:cell(operation)="row">
                <b-button
                  v-if="row.item._showDetails"
                  variant="danger"
                  @click="row.toggleDetails"
                  >بستن
                </b-button>
                <b-button v-else variant="primary" @click="row.toggleDetails"
                  >عملیات
                </b-button>
              </template>
              <template #row-details="row">
                <div
                  class="animated fadeIn"
                  style="text-align: center; vertical-align: middle"
                >
                  <b-button
                    class="mr-1"
                    variant="primary"
                    @click="openDetailDialog(row.item)"
                    >جزییات
                  </b-button>
                  <b-button
                    class="mr-1"
                    variant="success"
                    @click="openEditDialog(row.item)"
                    >ویرایش
                  </b-button>
                  <b-button
                    class="mr-1"
                    variant="warning"
                    @click="openChangeInventoryDialog(row.item)"
                    >تغییر موجودی
                  </b-button>
                </div>
              </template>

              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="warehouseInfo.allItems.length"
              :per-page="perPage"
              aria-controls="productsTable"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
            <br />
          </b-card>
        </b-tab>
        <b-tab title="رسید و حواله">
          <b-card header-bg-variant="secondary" header-text-variant="light">
            <template v-slot:header>
              <h5>
                رسید و حواله‌های <em>{{ warehouseInfo.name }}</em>
              </h5>
            </template>
            <v-row>
              <v-col cols="5">
                <b-form-group label="از تاریخ">
                  <date-picker
                    v-model="exchangeFrom"
                    :editable="true"
                  ></date-picker>
                </b-form-group>
              </v-col>
              <v-col cols="5">
                <b-form-group label="تا تاریخ">
                  <date-picker
                    v-model="exchangeTo"
                    :editable="true"
                  ></date-picker>
                </b-form-group>
              </v-col>
              <v-col cols="2" class="align-middle">
                <b-btn @click="searchExchanges()" class="btn btn-dark">
                  جستجو
                </b-btn>
              </v-col>
            </v-row>
            <b-table
              responsive
              show-empty
              id="detailsTable"
              :items="allExchanges"
              :fields="exchangesFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="exchangeCurrentPage"
              :per-page="exchangePerPage"
              :busy="exchangeIsBusy"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{
                    data.index + 1 + exchangePerPage * (exchangeCurrentPage - 1)
                  }}
                </div>
              </template>
              <template v-slot:cell(identifierEn)="data">
                <div style="text-align: center; vertical-align: middle">
                  <a
                    :href="
                      '/warehouse/' +
                      type.slug +
                      '/' +
                      data.item.warehouseItemId
                    "
                    target="_blank"
                    >{{ data.value }}</a
                  >
                </div>
              </template>
              <template v-slot:cell(operation)="row">
                <b-button
                  v-if="row.item._showDetails"
                  variant="danger"
                  @click="row.toggleDetails"
                  >بستن
                </b-button>
                <b-button v-else variant="primary" @click="row.toggleDetails"
                  >عملیات
                </b-button>
              </template>

              <template #row-details="row">
                <div
                  class="animated fadeIn"
                  style="text-align: center; vertical-align: middle"
                >
                  <b-button
                    class="mx-1"
                    variant="primary"
                    v-if="row.item.status != 'تایید نهایی'"
                    @click="submitCorrection(row.item, row.item.warehouseId)"
                    >اصلاح سند
                  </b-button>
                  <b-button
                    class="mx-1"
                    variant="success"
                    v-if="row.item.status != 'تایید نهایی'"
                    @click="approve(row.item)"
                    >تایید نهایی
                  </b-button>
                  <b-button
                    class="mx-1"
                    variant="danger"
                    v-if="row.item.status != 'تایید نهایی'"
                    @click="doDelete(row.item)"
                    >حذف تراکنش
                  </b-button>
                  <b-button
                    class="mx-1"
                    variant="warning"
                    v-if="row.item.status == 'تایید نهایی'"
                    @click="needEdit(row.item)"
                    >نیاز به اصلاح
                  </b-button>
                </div>
              </template>
              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
            <b-pagination
              v-model="exchangeCurrentPage"
              :total-rows="allExchanges.length"
              :per-page="exchangePerPage"
              aria-controls="detailsTable"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
            <br />
          </b-card>
        </b-tab>
      </b-tabs>
    </b-card>
    <v-dialog v-model="changeInventoryDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>تغییر موجودی</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="changeInventory-btn mt-3">
            <v-btn color="success" class="mb-4" @click="openEntryDialog()"
              >ورود کالا - افزایش موجودی</v-btn
            >
            <v-btn color="red" class="text-light mb-4" @click="openExitDialog()"
              >خروج کالا – کاهش موجودی</v-btn
            >
            <v-btn class="text-light mb-4 primary" @click="openTransferDialog()"
              >جابجایی کالا</v-btn
            >
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="entryDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ورود کالا - افزایش موجودی</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <b-form-group label="تاریخ ورود">
              <date-picker v-model="entry.date" :editable="true"></date-picker>
            </b-form-group>
            <v-text-field
              outlined
              dense
              label="حجم ورودی"
              v-model="entry.number"
              type="number"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="مبدا"
              v-model="entry.origin"
            ></v-text-field>
            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="entry.description"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="entryDialog = false">
            لغو
          </v-btn>
          <v-btn color="primary" @click="entrySubmit()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="exitDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>خروج کالا - کاهش موجودی</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <b-form-group label="تاریخ خروج">
              <date-picker v-model="exit.date" :editable="true"></date-picker>
            </b-form-group>
            <v-text-field
              outlined
              dense
              label="حجم خروجی"
              v-model="exit.number"
              type="number"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="مقصد"
              v-model="exit.origin"
            ></v-text-field>
            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="exit.description"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="exitDialog = false">
            لغو
          </v-btn>
          <v-btn color="primary" @click="exitSubmit()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="transferDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>جابجایی کالا</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-text-field
              outlined
              dense
              disabled
              label="جابجایی از"
              v-model="selected.warehouseSectionName"
            ></v-text-field>
            <v-select
              outlined
              dense
              label="جابجایی به"
              v-model="transfer.to"
              :items="otherWarehouses"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="transferDialog = false">
            لغو
          </v-btn>
          <v-btn color="primary" @click="transferSubmit()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ویرایش</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-row>
              <v-col cols="1" class="pb-0"
                ><v-checkbox
                  class="my-auto mt-1"
                  v-model="check.coating"
                  color="primary"
                  hide-details
                ></v-checkbox
              ></v-col>
              <v-col cols="11" class="pb-0">
                <v-text-field
                  :disabled="check.coating == false"
                  outlined
                  dense
                  label="پوشش"
                  v-model="edit.coating"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="1" class="py-0"
                ><v-checkbox
                  class="my-auto mt-1"
                  v-model="check.diameter"
                  color="primary"
                  hide-details
                ></v-checkbox
              ></v-col>
              <v-col cols="11" class="py-0">
                <v-text-field
                  :disabled="check.diameter == false"
                  outlined
                  dense
                  label="قطر"
                  v-model="edit.diameter"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="1" class="py-0"
                ><v-checkbox
                  class="my-auto mt-1"
                  v-model="check.length"
                  color="primary"
                  hide-details
                ></v-checkbox
              ></v-col>
              <v-col cols="11" class="py-0">
                <v-text-field
                  :disabled="check.length == false"
                  outlined
                  dense
                  label="طول"
                  v-model="edit.length"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="closeEditModal()">
            لغو
          </v-btn>
          <v-btn color="primary" @click="editProduct()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newProductDialog" max-width="600px">
      <v-card>
        <v-card-title style="padding-top: 38px">
          <h4>ثبت جدید</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-text-field
              outlined
              dense
              label="شرح فارسی *"
              v-model="newProduct.identifierFa"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="شرح انگلیسی *"
              dir="ltr"
              v-model="newProduct.identifierEn"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="نام"
              v-model="newProduct.name"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="متریال"
              v-model="newProduct.material"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="پوشش"
              v-model="newProduct.coating"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="استاندارد ابعاد"
              v-model="newProduct.dimensionStandard"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="قطر"
              v-model="newProduct.diameter"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="طول"
              v-model="newProduct.length"
            ></v-text-field>

            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="newProduct.description"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="newProductDialog = false"
          >
            لغو
          </v-btn>
          <v-btn color="primary" @click="addProduct()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>جزییات</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <br />
            <b-table
              responsive
              show-empty
              id="detailsTable"
              :items="info"
              :fields="fields2"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="currentPage"
              :per-page="perPage"
              :busy="isBusy2"
              :filter="filter"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>

              <template v-slot:cell(progress)="data">
                <b-progress
                  :value="data.item.progress"
                  variant="success"
                  :striped="striped"
                  show-progress
                  animated
                ></b-progress>
              </template>

              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="info.length"
              :per-page="perPage"
              aria-controls="detailsTable"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
            <br />
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="confirmDeleteDialog"
      max-width="500px"
      header-color="error"
    >
      <v-card>
        <v-card-title>
          <h4>حذف {{ selectedExchange.type }}</h4>
        </v-card-title>
        <v-card-text class="pb-0 pt-3 px-3">
          <v-container>
            <p>
              آیا از حذف {{ selectedExchange.type }} با مشخصات زیر مطمئن هستید؟
            </p>
            <p style="font-weight: bold; color: red">
              این کار غیر قابل برگشت است!
            </p>
            <b-table
              small
              responsive
              show-empty
              id="detailsTable"
              :items="[selectedExchange]"
              :fields="delExchangesFields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="currentPage"
              :per-page="perPage"
              :busy="isBusy"
              :filter="filter"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>

              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="confirmDeleteDialog = false">
            لغو
          </v-btn>
          <v-btn
            class="text-white"
            color="red"
            @click="doDelete(selectedExchange)"
          >
            حذف کن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editExchangeModal" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ویرایش {{ selectedExchange.type }}</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <b-form-group
              :label="
                selectedExchange.type == 'رسید' ? 'تاریخ ورود' : 'تاریخ خروج'
              "
            >
              <date-picker v-model="edit.date" :editable="true"></date-picker>
            </b-form-group>
            <b-form-group
              :label="
                selectedExchange.type == 'رسید' ? 'ساعت ورود' : 'ساعت خروج'
              "
            >
              <date-picker
                v-model="edit.time"
                :editable="true"
                type="time"
              ></date-picker>
            </b-form-group>
            <v-text-field
              outlined
              dense
              :label="
                selectedExchange.type == 'رسید' ? 'حجم ورودی' : 'حجم خروجی'
              "
              v-model="edit.amount"
              type="number"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              :label="selectedExchange.type == 'رسید' ? 'مبدا' : 'مقصد'"
              v-model="edit.orgDes"
            ></v-text-field>
            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="edit.note"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn
            class="text-white"
            color="red"
            @click="editExchangeModal = false"
          >
            لغو
          </v-btn>
          <v-btn color="primary" @click="editSubmit(selectedExchange)">
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <router-view></router-view>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";

import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import Var from "../../../variables"; // NOTE (IMPORT) to transfer variables from a special file of variables

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    
  },

  data: function () {
    return {
      guide: false,
      types: Var.allTypes,
      selectedExchange: {},
      selectedExchangeWarehouse: "",
      editExchangeModal: false,
      confirmDeleteDialog: false,
      edit: {},
      type: {},
      guide: false,
      warehouseInfo: {},
      products: [],
      otherWarehouses: [],
      productFilter: "all",
      changeInventoryDialog: false,
      entryDialog: false,
      exitDialog: false,
      transferDialog: false,
      editDialog: false,
      newProductDialog: false,
      detailDialog: false,
      advanceFilter: false,
      adFilter: {},
      info: [],
      selected: "",
      selected2: [],
      entry: {},
      exit: {},
      transfer: {},
      edit: {},
      newProduct: {},
      check: {
        name: false,
        material: false,
        coating: false,
        standard: false,
        diameter: false,
        length: false,
        number: false,
        description: false,
      },
      moment: moment,
      showProgress: false,
      items: [],
      filterOpt: [
        { key: "all", label: "همه" },
        { key: "exist", label: "اقلام دارای موجودی" },
        { key: "none", label: "اقلام بدون موجودی" },
      ],
      filter: null,
      fields: [
        { key: "index", label: "ردیف" },
        { key: "identifierFa", label: "شرح فارسی" },
        { key: "identifierEn", label: "شرح انگلیسی" },
        { key: "sum", label: "موجودی" },
        { key: "operation", label: "عملیات" },
      ],
      fields2: [
        { key: "index", label: "ردیف" },
        { key: "type", label: "نوع" },
        { key: "amount", label: "مقدار" },
        { key: "date", label: "تاریخ" },
      ],
      currentPage: 1,
      perPage: 10,
      isBusy: false,
      isBusy2: false,
      TotalRows: 1,
      exchangeFrom: "",
      exchangeTo: "",
      allExchanges: [],
      exchangesFields: [
        { key: "index", label: "ردیف" },
        { key: "type", label: "نوع" },
        { key: "identifierEn", label: "کالا" },
        { key: "amount", label: "مقدار" },
        { key: "status", label: "وضعیت" },
        { key: "note", label: "توضیحات" },
        { key: "orgDes", label: "مبدا / مقصد" },
        { key: "userName", label: "کاربر" },
        { key: "date", label: "تاریخ" },
        { key: "operation", label: "عملیات" },
      ],
      delExchangesFields: [
        { key: "type", label: "نوع" },
        { key: "amount", label: "مقدار" },
        { key: "status", label: "وضعیت" },
        { key: "note", label: "توضیحات" },
        { key: "orgDes", label: "مبدا / مقصد" },
        { key: "userName", label: "کاربر" },
        { key: "date", label: "تاریخ" },
        { key: "warehouseName", label: "انبار مربوطه" },
      ],
      exchangeCurrentPage: 1,
      exchangePerPage: 10,
      exchangeIsBusy: false,
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    submitCorrection(exchange, warehouseId) {
      this.selectedExchange = exchange;
      this.selectedExchangeWarehouse = warehouseId;
      this.editExchangeModal = true;
      this.edit = JSON.parse(JSON.stringify(exchange));
      try {
        let myDateTime = this.edit.date.split(" ");
        this.edit.date = myDateTime[0];
        this.edit.time = myDateTime[1];
        this.searchExchanges();
      } catch (error) {
        this.edit.date = moment(new Date()).format("jYYYY/jMM/jDD");
        this.edit.time = moment(new Date()).format("HH:mm");
      }
    },
    editSubmit(exchange) {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/editTransaction",
        {
          transactionId: exchange.id,
          amount: this.edit.amount,
          date: this.edit.date + " " + this.edit.time,
          orgDes: this.edit.orgDes,
          note: this.edit.note,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("تایید با موفقیت انجام شد", "success");
            this.editExchangeModal = false;
            this.searchExchanges();
            this.vLoading = false;
            this.isBusy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    approve(exchange) {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/confirmation",
        {
          transactionId: exchange.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("تایید با موفقیت انجام شد", "success");
            this.searchExchanges();
            this.vLoading = false;
            this.isBusy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    askDelete(exchange) {
      this.selectedExchange = exchange;
      this.confirmDeleteDialog = true;
    },
    doDelete(exchange) {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/delete",
        {
          transactionId: exchange.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("حذف با موفقیت انجام شد", "success");
            this.searchExchanges();
            this.vLoading = false;
            this.isBusy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    needEdit(exchange) {
      this.vLoading = true;
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/needEdit",
        {
          transactionId: exchange.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("ویرایش با موفقیت انجام شد", "success");
            this.searchExchanges();
            this.vLoading = false;
            this.isBusy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
    searchExchanges() {
      this.exchangeIsBusy = true;
      let startDate = this.exchangeFrom + " 00:00";
      let finishDate = this.exchangeTo + " 23:59";
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouse/exchanges",
        {
          warehouseId: this.$route.params.id,
          startDate: startDate,
          finishDate: finishDate,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.allExchanges = res.data;
            this.exchangeIsBusy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.allTotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    openChangeInventoryDialog(product) {
      this.changeInventoryDialog = true;
      this.selected = product;
    },
    openEntryDialog() {
      this.entryDialog = true;
      this.entry.date = "";
      this.entry.number = "";
      (this.entry.origin = ""), (this.entry.description = "");
    },
    openExitDialog() {
      this.exitDialog = true;
      this.exit.date = "";
      this.exit.number = "";
      (this.exit.origin = ""), (this.exit.description = "");
    },
    openTransferDialog() {
      this.transferDialog = true;
      this.transfer.to = "";
    },
    openEditDialog(product) {
      this.editDialog = true;
      this.selected2 = product;
      this.edit.name = product.name;
      this.edit.material = product.material;
      this.edit.coating = product.coating;
      this.edit.dimensionStandard = product.dimensionStandard;
      this.edit.diameter = product.diameter;
      this.edit.length = product.length;
      this.edit.number = product.number;
      this.edit.description = product.description;
    },
    closeEditModal() {
      this.editDialog = false;
      this.check.name = false;
      this.check.material = false;
      this.check.coating = false;
      this.check.standard = false;
      this.check.diameter = false;
      this.check.length = false;
      this.check.number = false;
      this.check.description = false;
    },
    openNewProductDialog() {
      this.selected = this.$route.params.id;
      this.newProduct.name = "";
      this.newProduct.material = "";
      this.newProduct.coating = "";
      this.newProduct.diameter = "";
      this.newProduct.length = "";
      this.newProduct.number = "";
      this.newProduct.description = "";
      this.newProduct.dimensionStandard = "";
      this.newProduct.identifierFa = "";
      this.newProduct.identifierEn = "";
      this.newProductDialog = true;
    },
    openDetailDialog(product) {
      this.detailDialog = true;
      this.selected = product.id;
      this.searchExchanges();
    },
    openAdvanceFilter() {
      this.advanceFilter = true;
      this.selected = this.$route.params.id;
    },
    advanecFilter() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItems/filter",
        {
          warehouseSectionId: this.$route.params.id,
          description: this.adFilter.description,
          material: this.adFilter.material,
          coating: this.adFilter.coating,
          dimensionStandard: this.adFilter.dimensionStandard,
          diameter: this.adFilter.diameter,
          length: this.adFilter.length,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.products = res.data;
            this.advanceFilter = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    delFilter() {
      this.adFilter.description = "";
      this.adFilter.material = "";
      this.adFilter.coating = "";
      this.adFilter.dimensionStandard = "";
      this.adFilter.diameter = "";
      this.adFilter.length = "";
      this.getProducts();
      this.advanceFilter = false;
    },
    getInfo() {
      this.isBusy2 = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/getInfo",
        {
          warehouseItemId: this.selected,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy2 = false;
          if (res.status == 200) {
            this.info = res.data.exchanges;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.isBusy2 = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    entrySubmit() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/entrance",
        {
          warehouseItemId: this.selected.id,
          amount: this.entry.number,
          date: this.entry.date,
          orgDes: this.entry.origin,
          note: this.entry.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.entryDialog = false;
            this.getProducts();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    exitSubmit() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/exit",
        {
          warehouseItemId: this.selected.id,
          amount: this.exit.number,
          date: this.exit.date,
          orgDes: this.exit.origin,
          note: this.exit.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.exitDialog = false;
            this.getProducts();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    transferSubmit() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/transfer",
        {
          warehouseItemId: this.selected.id,
          warehouseSectionId: this.transfer.to,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.transferDialog = false;
            this.changeInventoryDialog = false;
            this.getProducts();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    addProduct() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/new",
        {
          warehouseSectionId: this.selected,
          name: this.newProduct.name,
          description: this.newProduct.description,
          material: this.newProduct.material,
          coating: this.newProduct.coating,
          dimensionStandard: this.newProduct.dimensionStandard,
          diameter: this.newProduct.diameter,
          length: this.newProduct.length,
          number: this.newProduct.number,
          identifierEn: this.newProduct.identifierEn,
          identifierFa: this.newProduct.identifierFa,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.newProductDialog = false;
            this.getProducts();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    editProduct() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/convert",
        {
          warehouseItemId: this.selected2.id,
          coating: this.edit.coating,
          diameter: this.edit.diameter,
          length: this.edit.length,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.editDialog = false;
            this.check.name = false;
            this.check.material = false;
            this.check.coating = false;
            this.check.standard = false;
            this.check.diameter = false;
            this.check.length = false;
            this.check.number = false;
            this.check.description = false;
            this.getProducts();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    getProducts() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouse/id",
        {
          warehouseId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.warehouseInfo = res.data;
            this.type = this.types.filter(
              (x) => x.id == this.warehouseInfo.warehouseTypeId
            )[0];
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.isBusy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
  },

  mounted() {
    this.getProducts();
    this.exchangeTo = moment(new Date()).format("jYYYY/jMM/jDD");
    this.exchangeFrom = moment(new Date())
      .subtract(7, "d")
      .format("jYYYY/jMM/jDD");
    this.searchExchanges();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("./../../assets/fonts/IRANSans(FaNum).ttf");
}
.nav-pills {
  padding: 10px !important;
}
.changeInventory-btn {
  display: flex;
  align-items: center;
  flex-flow: column;
}
</style>
